import React from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const statusOf = (a) => {
  if (!a?.enabled) return null;
  if (!a.ready) return ["Il dealer non ha ancora inserito le credenziali: usa l'account Markoo", "text-muted-foreground"];
  if (a.status === "errore") return ["Credenziali rifiutate da Uno Mobile: pratiche bloccate", "text-rose-500"];
  return [`Credenziali impostate (${a.username})`, "text-emerald-600"];
};

export const UnoAccountAdmin = ({ dealer, acc, onSaved }) => {
  const save = async (patch) => {
    const body = { enabled: !!acc?.enabled, allow_markoo: !!acc?.allow_markoo, ...patch };
    try { const { data } = await api.put(`/admin/users/${dealer.id}/unomobile-account`, body); onSaved(dealer.id, data); toast.success(body.enabled ? "Account Uno Mobile proprio abilitato" : "Torna alle credenziali Uno Mobile di default"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore nell'aggiornamento"); }
  };
  const st = statusOf(acc);
  return <div className="space-y-1.5 pt-2" data-testid={`uno-account-${dealer.id}`}>
    <div className="flex items-center justify-between gap-2"><Label htmlFor={`uno-account-switch-${dealer.id}`} className="text-xs">Credenziali Uno Mobile proprie</Label><Switch id={`uno-account-switch-${dealer.id}`} checked={!!acc?.enabled} onCheckedChange={(v) => save({ enabled: v })} data-testid={`uno-account-switch-${dealer.id}`} /></div>
    {acc?.enabled && <div className="flex items-center justify-between gap-2"><Label htmlFor={`uno-account-markoo-${dealer.id}`} className="text-xs">Può usare anche il credito Markoo</Label><Switch id={`uno-account-markoo-${dealer.id}`} checked={!!acc.allow_markoo} onCheckedChange={(v) => save({ allow_markoo: v })} data-testid={`uno-account-markoo-${dealer.id}`} /></div>}
    {st && <p className={`text-[11px] ${st[1]}`} data-testid={`uno-account-status-${dealer.id}`}>{st[0]}</p>}
  </div>;
};
